/**
 * 프로젝트/용역 관련 상수 정의
 */

import { InspectionType, ProjectStatus } from '../@types';

/** 점검 종류 목록 */
export const INSPECTION_TYPES: InspectionType[] = [
    '정기안전점검',
    '정밀안전점검',
    '정밀안전진단',
    '기타(직접입력)'
];

/** 프로젝트 상태 목록 */
export const PROJECT_STATUSES: ProjectStatus[] = [
    '대기',
    '진행중',
    '완료',
    '중단'
];

/** 상태별 스타일 매핑 */
export const STATUS_STYLES: Record<ProjectStatus, { bg: string; text: string }> = {
    '대기': { bg: 'bg-gray-100', text: 'text-gray-500' },
    '진행중': { bg: 'bg-blue-50', text: 'text-blue-600' },
    '완료': { bg: 'bg-emerald-50', text: 'text-emerald-600' },
    '중단': { bg: 'bg-red-50', text: 'text-red-600' }
};

/** 점검 종류별 스타일 매핑 */
export const INSPECTION_TYPE_STYLES: Record<string, { bg: string; text: string }> = {
    '정기안전점검': { bg: 'bg-gray-100', text: 'text-gray-600' },
    '정밀안전점검': { bg: 'bg-amber-50', text: 'text-amber-600' },
    '정밀안전진단': { bg: 'bg-blue-50', text: 'text-blue-600' }
};

/** 프로젝트 폼 초기값 */
export const INITIAL_PROJECT_FORM = {
    project_no: '',
    title: '',
    category: '기타',
    type: '',
    type_etc: '',
    participants: '',
    start_date: '',
    end_date: '',
    contract_amount: '',
    client: '',
    supervisor_name: '',
    supervisor_phone: '',
    contract_manager_name: '',
    contract_manager_phone: ''
};

/** 프로젝트 통계 초기값 */
export const INITIAL_PROJECT_STATS = {
    total: 0,
    diagnosis: 0,
    inspection_fine: 0,
    inspection_regular: 0
};
